'use client';

import { useSearchParams } from 'next/navigation';
import { REGISTRATION_INVITE_PATHNAME, REGISTRATION_PATHNAME, VERIFICATION_PATHNAME } from '@/shared/constants/pathnames';
import { parseInviteCallbackUrl } from '@/shared/lib/invite/parse-invite-callback-url';


type LoginRedirect = {
    /** Email из ссылки-приглашения, если логин открыт с неё. */
    inviteEmail: string | null;
    redirectTo: string;
    /** Куда ведёт «Sign up»: обычная регистрация или регистрация по приглашению. */
    signUpHref: string;
};


export const useLoginRedirect = (): LoginRedirect => {
    const searchParams = useSearchParams();
    const redirectTo   = searchParams?.get('callbackUrl') ?? VERIFICATION_PATHNAME;
    const invite       = parseInviteCallbackUrl(redirectTo);

    return {
        redirectTo,
        inviteEmail: invite?.email ?? null,
        signUpHref : invite ? REGISTRATION_INVITE_PATHNAME(invite.token, invite.email) : REGISTRATION_PATHNAME,
    };
};
